<template>
<loading :show="show" :label="label" :overlay="overlay"></loading>
	<form class="form-horizontal">
	    <div class="form-body">

			
	        <div class="form-group" >

	        	<!-- Palavra chave -->
	        	<div class="col-md-7 input-palavra" v-if="dados.filtroPalavra == true" :style="'width: ' + dados.largura">
	                <label class="control-label">Palavra Chave</label>
	                <input type="text" class="form-control" placeholder="Insira Palavra chave">
	            </div>
		        <!-- Palavra chave -->

		        <!-- Entidade -->
		        <div class="col-md-5 new-padding-inputs input-entidade" v-if="dados.filtroEntidade == true">
		            <label class="control-label">Entidade</label>
		            <select class="form-control">
		                <option value="">Todas</option>
		                <option value="">Fundo Municipal de Assistencia Social de Aporá</option>
		                <option value="">Fundo Municipal de Saúde de Aporá</option>
		                <option value="">Prefeitura Municipal de Aporá</option>
		            </select>
		        </div>
		        <!-- Entidade -->

		        <!-- Modalidade -->
		        <div class="col-md-2 new-padding-inputs input-modalidade" v-if="dados.filtroModalidade == true">
		            <label class="control-label">Modalidade</label>
		            <select class="form-control">
		                <option value="">Todas</option>
		                <option value="">Lançamento</option>
		                <option value="">Recebimento</option>
		            </select>
		        </div>
		        <!-- Modalidade -->

				<!-- CPF/CNPJ -->        
		        <div class="col-md-3 new-padding-inputs input-cpfcnpj" v-if="dados.filtroCnpjcpf == true">
		            <label class="control-label">CPF/CNPJ</label>
		            <input type="text" class="form-control" placeholder="CPF">
		        </div>
		        <!-- CPF/CNPJ -->

		        <!-- Nome do Credor -->
		        <div class="col-md-5 new-padding-inputs input-credor" v-if="dados.filtroCredor == true">
		            <label class="control-label">Nome do Credor</label>
		            <input type="text" class="form-control" placeholder="Nome do Credor">
		        </div>
		        <!-- Nome do Credor -->

		        <!-- Tipo -->
		        <div class="col-md-2 new-padding-inputs input-tipo" v-if="dados.filtroTipo == true">
		            <label class="control-label">Tipo</label>
		            <select class="form-control">
		                <option value="">Todas</option>
		                <option value="">Orçamentaria</option>
		                <option value="">Extra Orçamentaria</option>
		            </select>
		        </div>
		        <!-- Tipo -->

		        <!-- Fase -->
		        <div class="col-md-3 new-padding-inputs input-fase" v-if="dados.filtroFase == true">
		            <label class="control-label">Fase</label>
		            <select class="form-control">
		                <option value="">Todos</option>
		                <option value="">Anulada</option>
		                <option value="">Contrato</option>
		                <option value="">Errata</option>
		                <option value="">Extrato de Aditivo</option>
		                <option value="">Edital de Licitação</option>
		            </select>
		        </div>
		        <!-- Fase -->

		        <!-- Ano -->
		        <div class="col-md-2 input-ano new-padding-inputs" v-if="dados.filtroAno == true">
		            <label class="control-label">Ano</label>
		            <select class="form-control">
		                <option value="">Todos</option>
		                <option value="">2012</option>
		                <option value="">2010</option>
		                <option value="">2008</option>
		            </select>
		        </div>
		        <!-- Ano -->

		        <!-- Mes -->
		        <div class="col-md-2 input-mes new-padding-inputs" v-if="dados.filtroMes == true">
		            <label class="control-label">Mes</label>
		            <select class="form-control">
		          		<option value="">Todos</option>
		                <option value="">Janeiro</option>
		                <option value="">Fevereiro</option>
		                <option value="">Março</option>
		                <option value="">Abril</option>
		                <option value="">Maio</option>
		                <option value="">Dezembro</option>
		            </select>
		        </div>
		        <!-- Mes -->

		        <!-- Numero do processo -->
		        <div class="col-md-2 new-padding-inputs input-processo" v-if="dados.filtroProcesso == true">
		            <label class="control-label">Nº Processo</label>
		            <input type="text" class="form-control" placeholder="">
		        </div>
		        <!-- Numero do processo -->

		        <!-- Numero da licitacao -->
		        <div class="col-md-2 new-padding-inputs input-licitacao" v-if="dados.filtroLicitacao == true">
		            <label class="control-label">Nº Licitacação</label>
		            <input type="text" class="form-control" placeholder="">
		        </div>
		        <!-- Numero da licitacao -->

		        <!-- Datas -->
		        <div class="col-md-2 input-data new-padding-inputs" v-if="dados.filtroData == true">
		            <label class="control-label" >Data Inicial</label>
		            <input type="text" class="form-control datepicker">
		        </div>
		        <div class="col-md-2 input-data new-padding-inputs" v-if="dados.filtroData == true">
		            <label class="control-label">Data Final</label>
		            <input type="text" class="form-control datepicker">
		        </div>
		        <!-- atas -->

		        <!-- Pesquisar -->
		        <div class="col-md-2 botao-pesquisar">
		            <label class="control-label"></label>
		           	<button class="form-control btn green" style="margin-top: 8px;" v-on:click="pesquisar">Pesquisar</button>
		        </div>
	        <!-- Pesquisar -->
	        </div>
	    </div>
	</form>
    <hr >
    <div>
        <div class="portlet-body">
            <div class="col-md-12">
            	<cp-table v-if="dados.tipotable == 'table1'" :dadosconteudo="dadosconteudo"></cp-table>
            	<cp-table-dois v-if="dados.tipotable == 'table2'" :dadosconteudo="dadosconteudo"></cp-table-dois>
            	<cp-table-cinco v-if="line == 'table5'" :dadosconteudo="dadosconteudo"></cp-table-cinco>
            </div>
        </div>
    </div>
</template>

<script>
	import CpTable from '../../tables/table-t1/table.vue'
    import CpTableCinco from '../../tables/table-t5/table.vue'
	import CpTableDois from '../../tables/table-t2/table.vue'
	import loading from 'vue-full-loading'

	export default{
		data(){
			return{
				dadosconteudo:{},
				show: false,
                label: 'Carregando...',
                overlay: true
			}
		},
        components:{
            CpTable, CpTableDois, CpTableCinco
        },
		props:['dados','line'],
		ready(){
			
			$.ajaxSetup({
                async: false
            })

            $.getScript( "./src/assets/assets-metronic/plugins/bootstrap-datepicker/js/bootstrap-datepicker.js");

            $.ajaxSetup({
                async: true
            });
            
            $('.datepicker').datepicker({
                 autoclose: true,
                 todayHighlight: true
            });
            $('form').bind('submit',function(e){e.preventDefault();});
		},
		methods:{
            pesquisar(ev){


                $.ajaxSetup({
                    async: false
                });

                var self = this;
                // if(this.$route.params.tipo == 'decisao'){
                //     $.getJSON('./src/components/tables/table-t1/datatable.json', function(links)
                //         {                
                //             self.dadosconteudo = links[0];
                //             //console.log(self.dadosconteudo)
                //     });
                // }

                // if(this.$route.params.tipo == 'anulada'){
                //     $.getJSON('./src/components/tables/table-t2/datatable2.json', function(links)
                //         {                
                //             self.dadosconteudo = links[0];
                //             //console.log(self.dadosconteudo)
                //     });
                // }

                // //json com os dados do menu
                // if(this.$route.params.tipo == 'diarias'){
                //     $.getJSON('./src/components/tables/table-t5/datatable2.json', function(links)
                //         {                
                //             self.dadosconteudo = links[0];
                //             //console.log(self.dadosconteudo)
                //     });
                // }


                $.ajaxSetup({
                    async: true
                });

            }
        }
	}
</script>
<style scoped>
	.input-palavra{
        width: 58.5%;
    }
</style>


// WEBPACK FOOTER //
// filtrogeral.vue?49c320ba